import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-8 md:pb-10 px-6" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <motion.div className="flex flex-col md:flex-row gap-6" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-190">
          {/* Pricing card */}
          <div className="flex-1 bg-brand-card rounded-2xl border border-white/10 overflow-hidden shadow-lg shadow-brand-green/5" data-id="element-191">
            {/* Banner */}
            <div className="bg-brand-green py-3 text-center" data-id="element-192">
              <span className="text-brand-bg text-sm font-bold uppercase tracking-widest" data-id="element-193">
                Lanzamiento Argentina
              </span>
            </div>

            <div className="px-8 py-10 text-center" data-id="element-194">
              <p className="text-lg font-semibold text-brand-dark mb-6" data-id="element-195">
                Acceso inmediato a la guía
              </p>

              <div className="mb-8" data-id="element-196">
                <p className="text-xl text-brand-dark/40 line-through mb-2" data-id="element-197">
                  $150.000 ARS
                </p>
                <p className="flex items-baseline justify-center gap-1" data-id="element-198">
                  <span className="text-lg text-brand-dark/40" data-id="element-199">$</span>
                  <span className="text-5xl md:text-6xl font-bold text-brand-dark" data-id="element-200">
                    49.900
                  </span>
                  <span className="text-lg text-brand-dark/50 ml-1" data-id="element-201">ARS</span>
                </p>
                <p className="text-sm font-semibold text-brand-green mt-4" data-id="element-202">
                  Precio lanzamiento por tiempo limitado
                </p>
              </div>

              <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xs mx-auto bg-brand-green hover:bg-brand-green-hover text-brand-bg font-bold text-lg py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 text-center mb-4" data-id="element-203">
                🔥 Acceder Ahora
              </a>

              <p className="text-sm text-brand-dark/50 mb-2" data-id="element-204">
                Actualizaciones incluidas +{' '}
                <strong className="text-brand-dark/70" data-id="element-205">
                  Acceso a toda la información que necesitas
                </strong>
              </p>
              <p className="text-sm text-brand-dark/40" data-id="element-206">
                Pago 100% seguro • Mercado Pago
              </p>
              <p className="text-sm text-brand-dark/60 mt-3" data-id="element-207">
                🎁 + de regalo 3 bonos valorados en $25.000 totalmente{' '}
                <strong className="text-brand-green" data-id="element-208">¡GRATIS!</strong>
              </p>
              <p className="text-sm text-brand-dark/50 mt-2" data-id="element-209">
                📩 Acceso inmediato al eBook después del pago, se envía a tu
                correo electrónico
              </p>
            </div>
          </div>

          {/* Benefits card */}
          <div className="md:w-64 bg-brand-card rounded-2xl border border-white/10 p-8 flex flex-col justify-center" data-id="element-210">
            <div className="space-y-6" data-id="element-211">
              <div className="flex items-start gap-3" data-id="element-212">
                <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-213" />
                <p className="text-sm text-brand-dark/70 leading-relaxed" data-id="element-214">
                  Único pago. Sin suscripciones ni pagos extra.
                </p>
              </div>

              <div className="border-t border-dashed border-white/10" data-id="element-215" />

              <div className="flex items-start gap-3" data-id="element-216">
                <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-217" />
                <p className="text-sm text-brand-dark/70 leading-relaxed" data-id="element-218">
                  Entrás hoy y empezás a aplicar en horas (aunque no tengas
                  experiencia).
                </p>
              </div>

              <div className="border-t border-dashed border-white/10" data-id="element-219" />

              <div className="flex items-start gap-3" data-id="element-220">
                <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-221" />
                <p className="text-sm text-brand-dark/70 leading-relaxed" data-id="element-222">
                  Acceso inmediato + guía paso a paso.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}